import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  // eslint-disable-next-line consistent-return
  async getYears(params) {
    try {
      const response = await axios.get('categories/factYears/all', { params })
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
  },
  // eslint-disable-next-line consistent-return
  async getData(params) {
    try {
      const response = await axios.get('uni/scholarshipLevel', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
  async create(params) {
    try {
      const response = await axios.post('uni/scholarshipLevel', params)
      const { data } = response
      const isSuccessful = data.code === ApiCode.SUCCESS
      if (isSuccessful) {
        return { isSuccessful, message: data.message }
      }
      return { isSuccessful, message: data.debugMessage }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async update(params) {
    try {
      const response = await axios.put(`uni/scholarshipLevel/${params.id}`, params)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async delete(id) {
    try {
      const response = await axios.delete(`uni/scholarshipLevel/${id}`)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
